import { fetchListingCollections } from '../../ducks/listingCollections.duck';
import { COLLECTION_SOURCES } from '../../util/listingCollections';
import { hasCategoryRegionPage, regionalFirst } from '../../util/categoryRegions';
import { cantonBySlug } from '../../util/regions';
import * as log from '../../util/log';
import { categoryCollection } from './CategoryLandingPage.duck';
import { regionCollection } from './RegionLandingPage.duck';

const CARD_LIMIT = 12;

export const categoryRegionCollectionId = (slug, region) => `category-${slug}-region-${region}`;

/**
 * The combined category and canton filter, or null when the pair has no page
 * or the Region field can't be queried.
 *
 * @param {Object} params route params { slug, region }
 * @param {Object} config marketplace config
 * @returns {Object|null} sdk.listings.query filter params
 */
export const categoryRegionFilters = (params, config) => {
  const canton = cantonBySlug(params?.region);
  const category = categoryCollection(params?.slug);
  const region = regionCollection(params?.region, config);
  if (!canton || !category || !region || !hasCategoryRegionPage(params.slug, canton.option)) {
    return null;
  }
  return { ...category.params, ...region.params };
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const filters = categoryRegionFilters(params, config);
  if (!filters) {
    return Promise.resolve();
  }

  // Pick the cards from a light query first, so only the twelve shown reach the
  // server-rendered state rather than up to a hundred listings with images.
  return sdk.listings
    .query({
      ...filters,
      perPage: 100,
      'fields.listing': ['publicData'],
      include: ['author'],
      'fields.user': [],
    })
    .then(response => {
      const ids = regionalFirst(response.data.data, CARD_LIMIT).map(l => l.id.uuid);
      if (!ids.length) {
        return null;
      }
      const collection = {
        id: categoryRegionCollectionId(params.slug, params.region),
        source: COLLECTION_SOURCES.QUERY,
        params: { ids },
        limit: CARD_LIMIT,
      };
      return dispatch(fetchListingCollections([collection], { config }));
    })
    .catch(e => {
      log.error(e, 'fetch-category-region-listings-failed', params);
      return null;
    });
};
